import React, {Component} from 'react';
import {connect} from 'react-redux';
import oitsActionCreators from "../../subscriber-app/store/oits/action-creators/oits";
import departmentSettingsSelectors from "../../subscriber-app/store/department-settings/selectors";


function mapStateToProps(state) {
  return {
    oits: state.oits.list,
    oitShortLabel: departmentSettingsSelectors.oitShortLabel(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loadOitsContainer: (scope) => {
      return dispatch(oitsActionCreators.loadOitsContainer(scope, 'all'));
    },
  }
}

class OitPicker extends Component {
  componentDidMount() {
    this.props.loadOitsContainer();
  }

  render() {
    return (

      <select
        style={{width: '100%'}}
        className="form-control"
        value={this.props.value}
        onChange={(e) => this.props.onChange(e.target.value)}
        onBlur={(e) => this.props.onBlur && this.props.onBlur(e.target.value)}>
        {!this.props.value && <option value="" disabled>Select {this.props.oitShortLabel}</option>}
        {this.props.oits.map((oit) => (
          <option
            key={oit.guid}
            value={oit.guid}>
            {oit.getFullName()}
          </option>
        ))}
      </select>

    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OitPicker);
